import ticket from './ticket'
import problem from './problem'
import ticketRestructure from './ticketRestructure/ticketRestructure'

const TicketServer = {
    ticket,
    problem,
    ticketRestructure,
};

export default TicketServer;
